import { selectors as authSelectors } from '@hixme/auth-ui'
import { ROLE_PLATFORM_HIXME_ADMIN } from '@hixme/role-policy'
import { NOT_FOUND_PATH } from 'constants/route'
import useCustomerConfiguration from 'enrollment-platform/pages/CustomerManagement/pages/ViewCustomer/hooks/useCustomerConfiguration'
import React, { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { browserHistory } from 'react-router'
import { selectors as userSessionSelectors } from 'store/modules/user-session'
import { CENSUS_MANAGEMENT_PATH, CENSUS_MANAGEMENT_V1 } from '../constants'

type CensusManagementRouteProviderProps = {
  children: React.ReactNode
  version: 'v1' | 'v2'
}

export const CensusManagementRouteProvider = ({
  children,
  version,
}: CensusManagementRouteProviderProps) => {
  const role = useSelector(authSelectors.getRole)
  const currentSelectedCompanyId = useSelector(
    userSessionSelectors.getCurrentCompanyId
  )
  const isPlatformAdmin = role === ROLE_PLATFORM_HIXME_ADMIN

  const { queryToggles } = useCustomerConfiguration(
    currentSelectedCompanyId || ''
  )
  const { data: configuration, isLoading, isError } = queryToggles()

  const isCMv1Enabled = isPlatformAdmin
    ? true
    : (configuration?.isCMv1Enabled ?? false)
  const isCMv2Enabled = isPlatformAdmin
    ? true
    : (configuration?.isCMv2Enabled ?? false)
  const isVersion1 = version === 'v1'
  const shouldBlock = useMemo(
    () => (isVersion1 ? !isCMv1Enabled : !isCMv2Enabled),
    [version, isCMv1Enabled, isCMv2Enabled]
  )
  const isOtherVersionEnabled = useMemo(
    () => (isVersion1 ? isCMv2Enabled : isCMv1Enabled),
    [version, isCMv1Enabled, isCMv2Enabled]
  )

  useEffect(() => {
    if (!isLoading && shouldBlock) {
      if (isOtherVersionEnabled) {
        // redirect to the other version page if it is enabled
        browserHistory.replace(
          isVersion1 ? CENSUS_MANAGEMENT_PATH : CENSUS_MANAGEMENT_V1
        )
      } else {
        browserHistory.replace(NOT_FOUND_PATH)
      }
    }
  }, [isLoading, shouldBlock, isError])

  if (isLoading || shouldBlock) {
    return null
  }

  return <>{children}</>
}

export default CensusManagementRouteProvider
